<template>
    <a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose">
        <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="id" name="id">
                    <a-input v-model:value="form.id"/>
                </a-form-item>
            </div>
            <a-form-item label="用户名" name="account">
                <a-input v-model:value="form.account" placeholder="请输入用户名"/>
            </a-form-item>

            <a-form-item label="姓名" name="nickname">
                <a-input v-model:value="form.nickname" placeholder="请输入昵称"/>
            </a-form-item>
            <a-form-item label="邮箱" name="email">
                <a-input v-model:value="form.email" placeholder="请输入邮箱"/>
            </a-form-item>
            <a-form-item label="角色" name="roleIds">
                <multiple-select v-model:value="form.roleIds" :options="options" title-name="name" value-name="id"/>
            </a-form-item>
            <a-form-item label="启用状态" name="enable">
                <switch-input v-model:value="form.enable" :checkedValue="0" :uncheckedValue="1"/>
            </a-form-item>
            <!--可编辑区域 end-->
        </a-form>
    </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {sys_admin, sys_role} from "@/api/adminService";
import {company} from "@/config/variableConfig";

export default {
    name: "UserModal",
    components: {},

    mixins: [formMixin],
    data() {
        return {
            company,
            form: {
                parentId: null,
            },
            rules: {
                account: [dataCheck.required({}),],
                nickname: [dataCheck.required({})],
                roleIds: [dataCheck.required({})],
                email: [],
                enable: [dataCheck.required({type: 'number'})],
                id: [],
            },

            options: [],
            // userTypeOpts: [
            //     {title: '客服', value: '1'},
            //     {title: '项目经理', value: '2'},
            //     {title: '销售总监', value: '3'},
            //     {title: '服务公司主管', value: '20'},
            //     {title: '服务公司服务人员', value: '21'},
            //     {title: '系统管理', value: '0'},
            // ],
            submitUrl: sys_admin.saveupdate
        }
    },
    // computed: {
    //     submitUrl() {
    //         return this.form.id ? sys_admin.update : sys_admin.save
    //     }
    // },
    created() {
        this.getRoleListData()
    },
    methods: {
        getRoleListData() {
            this.getAction({
                url: sys_role.getRoleList
            }).then(res => {
                this.options = res
            })
        }
    },
}
</script>
<style scoped lang="less">
</style>
